import { render, staticRenderFns } from "./My.vue?vue&type=template&id=06827d37&scoped=true&"
import script from "./My.vue?vue&type=script&lang=js&"
export * from "./My.vue?vue&type=script&lang=js&"
import style0 from "./My.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./My.vue?vue&type=style&index=1&id=06827d37&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06827d37",
  null
  
)

export default component.exports